import React from 'react';
import '../styles/sections/faq.scss';
import Accordion from "../components/accordion";

function HeadingWithIcons(props) {  
    const questions = props.data.questions;
  return (
    <div className="faq">
        <div className="innerBox">
            <h3 className="sectionHeading">Frequently asked questions</h3>
            <div className="accordions">
            {questions.map((question, index) =>
                <Accordion
                    key={question.key}
                    count={question.key}
                    title={question.q}
                    content={question.a}
                />
            )} 
            </div>
        </div>
    </div>
  )
};

export default HeadingWithIcons; 